import request from '@/utils/request';
/**
 * 添加随手记
 */
export const addMemorandum = (data) => {
  return request.post('/user/memorandum/add', data);
};
/**
 * 随手记分页查询
 */
export const queryMemorandum = (data) => {
  return request.post('/user/memorandum/page', data);
};
/**
 * 修改随手记
 */
export const changeMemorandum = (data) => {
  return request.post('/user/memorandum/edit', data);
};
/**
 * 删除随手记
 */
export const deleteMemorandum = (data) => {
  return request.post('/user/memorandum/delete?id=' + data);
};
// 保存操作记录
const baseURLAdmin = process.env.VUE_APP_ADMIN;
export const sysOperateLogSave = (data) => {
  return request({
    url: '/sysOperateLog/save',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 查询操作记录
export const sysOperateLogPage = (data) => {
  return request({
    url: '/sysOperateLog/pageQuery',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
